$(function(){
	var myIndexSelected = 0;
	var myNewSelected = 0;
	var newsSwiper = new Swiper('.liste-swiper', {
		slidesPerView: 1,
		autoplay:4000,
		speed: 1200,
		pagination: '.my-swiper-pagination',
		paginationClickable: true,
		autoplayDisableOnInteraction: false,
		onSlideChangeStart: function() {
			var lengthSlide = $('.content-top-conseil .swip-txt').length;
			myIndexSelected = $('.liste-swiper .swiper-pagination-bullet-active').index();

			if(myIndexSelected <= myNewSelected){
				myNewSelected = myIndexSelected--;
				$('.content-top-conseil .swip-txt').css({display:'none'});
				$('.content-top-conseil .swip-txt:eq('+myNewSelected+')').fadeIn();
			}
			else{
				myNewSelected = myIndexSelected++;
				$('.content-top-conseil .swip-txt').css({display:'none'});
				$('.content-top-conseil .swip-txt:eq('+myNewSelected+')').fadeIn();
			}

		},
		paginationBulletRender: function (index, className) {
			return '<div class="' + className + '"></div>';
		}
	}); 	

	var openFiltre = false;
	$('.select-filtre').click(function(){
	    if(openFiltre == false){
	      $(this).parent().find('ul').slideDown(function(){
	        openFiltre = true;
	      });
	    }
	    else{
	      $(this).parent().find('ul').slideUp(function(){
	        openFiltre = false;
	      });
	    }		
	});

});